import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import appConfig from "./appConfig";

let sentryInited = false;
export const useInitSentry = () => {
  useEffect(() => {
    if (appConfig && appConfig.companyName && !sentryInited && appConfig.sentryDsn) {
      Sentry.init({
        dsn: appConfig.sentryDsn,
        tunnel: "/api-proxy/sentry/log",
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            useCompression: false,
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
            maskFn: s => s
          }),
          Sentry.browserApiErrorsIntegration(),
          Sentry.captureConsoleIntegration({
            levels: ["error", "warn"]
          }),
          Sentry.extraErrorDataIntegration(),
          Sentry.httpClientIntegration()
        ],
        attachStacktrace: true,
        // Performance Monitoring
        tracesSampleRate: 1, //  Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 1,
        replaysOnErrorSampleRate: 1,
        environment: window.location.hostname.includes("dev") ? "development" : "production",
        sendDefaultPii: true,
        maxValueLength: 100000
      });

      if (Sentry.isInitialized()) {
        Sentry.setUser({
          email: appConfig.visitorId,
          id: appConfig.visitorId,
          username: appConfig.visitorId
        });

        Sentry.setTags({
          companyName: appConfig.companyName,
          host: window.location.hostname,
          environment: window.location.hostname.includes("dev") ? "development" : "production",
          application: "microsite"
        });

        sentryInited = true;
      }

      return () => {
        Sentry.close();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);
};
